// extracted by mini-css-extract-plugin
export default {"openGraphContainer":"d_w","btn":"d_x"};